import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import useAssessmentService, { CREATE_ASSESSMENT } from 'domain/people/employee/assessment/assessmentService';
import { useAuthorization } from 'framework/authorization';
import { ModalFormButton } from 'framework/form';
import AssessmentForm from '../../createupdate/AssessmentForm';
import { useListContext } from 'framework/list';
import { useIsMyProfile } from 'domain/shared/employee';

const AddAssessmentButton = () => {
  const isMyProfile = useIsMyProfile();
  const { isGranted } = useAuthorization();
  const { create, getValidationSchema } = useAssessmentService();
  const { reloadData = () => {} } = useListContext();

  if (!isGranted(CREATE_ASSESSMENT) || isMyProfile) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle="Add assessment to employee"
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Assessment has been successfully added.',
        execute: () => {
          reloadData();
        },
      }}
      label={<AddIcon fontSize="small" />}
      submitFormFunc={create}
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      modalSize="sm"
      sxButton={{
        minWidth: 'auto',
        p: 0,
      }}
    >
      <AssessmentForm />
    </ModalFormButton>
  );
};

export default AddAssessmentButton;
